import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_ORIGIN = BACKEND_URL;

const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("konzade_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("konzade_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function apiError(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return err?.message || "Bir hata oluştu";
}

// Resolve an image url that may be a relative /api/uploads path
export function resolveImg(url) {
  if (!url) return "";
  if (url.startsWith("/api/uploads")) return `${API_ORIGIN}${url}`;
  return url;
}

export const CURRENCIES = { TRY: "₺", EUR: "€", USD: "$" };

export const QUOTE_STATUS = {
  draft: { label: "Taslak", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  sent: { label: "Gönderildi", cls: "bg-blue-100 text-blue-700 border-blue-200" },
  approved: { label: "Onaylandı", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  rejected: { label: "Reddedildi", cls: "bg-rose-100 text-rose-700 border-rose-200" },
};

export function money(n, cur = "TRY") {
  const sym = CURRENCIES[cur] || "₺";
  const val = Number(n || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${sym}${val}`;
}

// Compute quote profitability from item cost/sale prices.
// Not calculable if any item is missing a positive cost_price or unit_price.
export function computeProfit(quote) {
  const items = (quote && quote.items) || [];
  if (!items.length) return { calculable: false };
  let revenue = 0, cost = 0;
  for (const it of items) {
    const qty = Number(it.quantity) || 0;
    const up = Number(it.unit_price) || 0;
    const cp = Number(it.cost_price) || 0;
    if (up <= 0 || cp <= 0) return { calculable: false };
    const disc = Number(it.discount_percent) || 0;
    revenue += qty * up * (1 - disc / 100);
    cost += qty * cp;
  }
  const gd = Number(quote.total_discount_percent) || 0;
  revenue = revenue * (1 - gd / 100);
  const profit = revenue - cost;
  const rate = cost > 0 ? (profit / cost) * 100 : 0;
  return { calculable: true, profit, cost, revenue, rate };
}

export const ROLE_LABEL = { admin: "Yönetici", manager: "Müdür", staff: "Personel" };

// Convert amount between currencies using manual TL-based rates (rates.usd/eur = TL per 1 unit).
// Returns null when a required rate is missing/zero so callers can keep the original value + warn.
export function convertCurrency(amount, from, to, rates) {
  amount = Number(amount) || 0;
  from = from || "TRY";
  to = to || "TRY";
  if (from === to) return amount;
  const r = { TRY: 1, USD: Number(rates?.usd) || 0, EUR: Number(rates?.eur) || 0 };
  if (!r[from] || !r[to]) return null;
  return (amount * r[from]) / r[to];
}

export default api;
